import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import { contact, media, navLinks } from "../data/siteData";

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);

  return (
    <header data-testid="site-header" className="fixed top-0 z-50 w-full border-b border-white/10 bg-[#0C0A09]/70 backdrop-blur-2xl">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 md:px-10">
        <Link data-testid="header-logo-link" to="/" onClick={closeMenu} className="group flex items-center">
          <img
            data-testid="header-logo-image"
            src={media.logo}
            alt="Kannur Surf Club"
            className="h-14 w-40 object-contain object-left drop-shadow-[0_0_18px_rgba(255,255,255,0.18)] transition-transform duration-300 group-hover:scale-105 md:h-16 md:w-52"
          />
        </Link>

        <nav data-testid="desktop-navigation" className="hidden items-center gap-8 lg:flex">
          {navLinks.map((link) => (
            <NavLink
              data-testid={`desktop-nav-${link.label.toLowerCase().replaceAll(" ", "-")}`}
              key={link.path}
              to={link.path}
              className={({ isActive }) =>
                `text-sm uppercase tracking-[0.18em] transition-colors duration-300 ${isActive ? "text-[#FF5E3A]" : "text-slate-300 hover:text-white"}`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <Button data-testid="header-book-now-button" asChild className="rounded-xl bg-[#FF5E3A] px-7 font-semibold uppercase tracking-[0.16em] text-white shadow-[0_0_24px_rgba(255,94,58,0.18)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#FF7B5C]">
            <a href={contact.whatsappIntents.bookSession} target="_blank" rel="noreferrer">Book Now</a>
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle-button"
          type="button"
          aria-label="Toggle navigation"
          onClick={() => setOpen((value) => !value)}
          className="grid h-11 w-11 place-items-center rounded-xl border border-white/15 text-white transition-colors duration-300 hover:border-[#FF5E3A] lg:hidden"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-navigation" className="border-t border-white/10 bg-[#0A0F1C]/95 px-5 py-6 lg:hidden">
          <div className="flex flex-col gap-5">
            {navLinks.map((link) => (
              <NavLink
                data-testid={`mobile-nav-${link.label.toLowerCase().replaceAll(" ", "-")}`}
                key={link.path}
                to={link.path}
                onClick={closeMenu}
                className="text-sm uppercase tracking-[0.18em] text-slate-200"
              >
                {link.label}
              </NavLink>
            ))}
            <Button data-testid="mobile-book-now-button" asChild className="rounded-xl bg-[#FF5E3A] font-semibold uppercase tracking-[0.16em] text-white hover:bg-[#FF7B5C]">
              <a href={contact.whatsappIntents.bookSession} target="_blank" rel="noreferrer" onClick={closeMenu}>Book Now</a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};
